
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/_outdoor-run.scss';

const outdoorRunImage = require('../assets/outdoor-run.png');

const sessions = [
  {
    id: 1,
    title: 'Session 1: Park Virtual Run',
    path: '/panel/dashboard/outdoor-run/session-1',
  },
  {
    id: 2,
    title: 'Session 2: Beach Virtual Run',
    path: '/panel/dashboard/outdoor-run/session-2',
  },
  {
    id: 3,
    title: 'Session 3: Forest Trail Run',
    path: '/panel/dashboard/outdoor-run/session-3',
  },
];

const OutdoorRunPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  return (
    <div className={`resources-page${isDarkMode ? ' dark' : ''}`}> 
      <div className="module-resources_container">
        <div className="module-resources_header">
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Outdoor Run</h2>
            </div>
          </div>
        </div>
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            {sessions.map((s) => (
              <div 
                key={s.id} 
                className="module-resources_module-card"
                onClick={() => navigate(s.path)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') navigate(s.path);
                }}
              >
                <div className="module-resources_module-image">
                  <img src={outdoorRunImage.default || outdoorRunImage} alt={s.title} />
                </div>
                <div className="module-resources_module-content">
                  <h3 className="module-resources_module-title">{s.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutdoorRunPage;

